/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Row, Table } from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import BreadCrumb from '../../../components/Label/Breadcrumb'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import Loading from '../../../components/atoms/Loading'
import toast, { Toaster } from 'react-hot-toast'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const WorkOrderRepackCreate = () => {
  const { code } = useParams()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const columnTarget = [
    { key: 'sequence', label: 'No' },
    { key: 'item', label: 'Item' },
    {
      key: 'batch',
      label: 'Batch',
      className: 'text-end',
      component: (value) => value?.batch || '-'
    },
    {
      key: 'expired',
      label: 'Expired',
      className: 'text-end',
      component: (value) =>
        value?.expired
          ? convertDateWithTime(value?.expired, 'DD-MM-YYYY, HH:mm')
          : '-'
    },
    {
      key: 'qty_pack',
      label: 'Qty@Pack',
      className: 'text-end',
      component: (value) => value?.qty_pack || '-'
    },
    {
      key: 'total_qty',
      label: 'Total Qty',
      className: 'text-end',
      component: (value) => value?.total_qty || '-'
    },
    {
      key: 'uom',
      label: 'UOM',
      className: 'text-end',
      component: (value) => value?.uom || '-'
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value?.total_pack} ${value?.uom_pack}` : '-'
    }
  ]
  const columnSource = [
    { key: 'sequence', label: 'No' },
    { key: 'item', label: 'Item' },
    { key: 'item_code', label: 'Item Code' },
    {
      key: 'batch',
      label: 'Batch',
      className: 'text-end',
      component: (value) => value?.batch || '-'
    },
    {
      key: 'total_qty',
      label: 'Total Qty',
      className: 'text-end',
      component: (value) =>
        value?.total_qty ? `${value?.total_qty} ${value?.uom}` : '-'
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value?.total_pack} ${value?.uom_pack}` : '-'
    },
    {
      key: 'location',
      label: 'Location',
      className: 'text-end',
      component: (value) => (
        <div
          key={value.item}
          className="d-flex justify-content-end"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={value?.location || '-'}
        >
          {['', null, undefined].includes(value?.location) ? (
            <span>-</span>
          ) : (
            <Link
              to="/workorder/plan/location"
              replace={true}
              state={{
                ...state,
                code,
                type: 'repack',
                location: value
              }}
              style={{
                color: '#007bff',
                textDecoration: 'none',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                maxWidth: '120px',
                verticalAlign: 'bottom'
              }}
              title={value.location}
            >
              {value.location}
            </Link>
          )}
        </div>
      )
    }
  ]

  const fetchDetailWorkOrder = async () => {
    try {
      setIsLoading(true)
      const params = {
        wo: code || '',
        suggest: 1
      }
      const res = await api.get('/outbound/work-order-repack/detail', {
        params
      })
      const { data } = res.data
      setData(data)
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      navigate('/workorder/repack', {
        replace: true,
        state: state
      })
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setIsLoading(false)
    }
  }
  const handleBack = () => {
    navigate(`/workorder/repack/detail/${code}`, {
      replace: true,
      state: state
    })
  }

  const handleSubmit = async () => {
    try {
      setLoadingSubmit(true)
      const payload = {
        wo: data?.code,
        type: data?.type,
        series: state?.seriesNumber,
        warehouse_id: data?.warehouse,
        target: data?.target || [],
        sources: data?.sources || []
      }
      const res = await api.post('outbound/work-order-repack/job', payload)
      const { data: dataResponse } = res
      if (dataResponse?.success) {
        toast.success('Create Job Manufacture Success', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        navigate(`/workorder/repack/detail/${code}`, {
          replace: true,
          state: state
        })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoadingSubmit(false)
    }
  }

  const disableSubmit = () => {
    // Find any source item where item_code does NOT start with 'P' (case-insensitive)
    const isItemNotPacking = data?.sources
      ?.filter((item) => !/^P/i.test(item.item_code))
      .some((item) => ['', null, undefined].includes(item.location))
    if (loadingSubmit || isItemNotPacking) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (!state) {
      toast.error('Please select a work order', {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      navigate('/workorder/repack', {
        replace: true,
        state: null
      })
    }
    fetchDetailWorkOrder()
  }, [state])

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Toaster />
      <Container>
        <Row className="mb-3">
          <Col md={4}>
            <BreadCrumb
              label="CREATE JOB MANUFACTURE"
              link={`/workorder/repack/detail/${code}`}
              back="CREATE"
              subLabel={code}
              status=""
              type=""
              stateValue={state}
            />
          </Col>
        </Row>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            TARGET
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columnTarget.map((column) => (
                  <th
                    className={`align-middle p-2 ${column.className}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.target?.length === 0 && (
                <tr>
                  <td colSpan={columnTarget.length} className="p-3">
                    <div className="d-flex justify-content-center">
                      <span className="text-secondary">No data available</span>
                    </div>
                  </td>
                </tr>
              )}
              {data?.target?.length > 0 &&
                data?.target?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnTarget.map((column) => (
                      <td
                        key={column.key}
                        className={`align-middle p-2 ${column.className}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            SOURCE
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columnSource.map((column) => (
                  <th
                    className={`align-middle p-2 ${column.className}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.sources?.length === 0 && (
                <tr>
                  <td colSpan={columnSource.length} className="p-3">
                    <div className="d-flex justify-content-center">
                      <span className="text-secondary">No data available</span>
                    </div>
                  </td>
                </tr>
              )}
              {data?.sources?.length > 0 &&
                data?.sources?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnSource.map((column) => (
                      <td
                        key={column.key}
                        className={`align-middle p-2 ${column.className}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card>

        <div className="d-flex justify-content-between mb-3">
          <Button
            variant="transparent"
            className="text-danger fw-bold"
            onClick={handleBack}
          >
            Cancel
          </Button>
          <Button
            variant="transparent"
            className={`${
              disableSubmit()
                ? 'btn-secondary opacity-25 '
                : 'btn-primary-orange'
            }`}
            onClick={handleSubmit}
            disabled={disableSubmit()}
          >
            {loadingSubmit ? 'Submitting...' : 'Submit'}
          </Button>
        </div>
      </Container>
    </>
  )
}
export default WorkOrderRepackCreate
